import React, { useEffect, useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "./Layout.css";

const MOBILE_QUERY = "(max-width: 1100px)";

/**
 * Application shell for the signed-in area: fixed sidebar, sticky top bar and
 * the scrolling page body.
 */
export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(
    () => !window.matchMedia(MOBILE_QUERY).matches
  );

  // The sidebar overlays the page on narrow screens, so it starts closed there.
  useEffect(() => {
    const media = window.matchMedia(MOBILE_QUERY);
    const handleChange = (event) => setSidebarOpen(!event.matches);
    media.addEventListener("change", handleChange);
    return () => media.removeEventListener("change", handleChange);
  }, []);

  return (
    <div className={`shell${sidebarOpen ? " shell--sidebar-open" : ""}`}>
      <Sidebar open={sidebarOpen} />

      {sidebarOpen && (
        <button
          type="button"
          className="shell__scrim"
          aria-label="Close navigation"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <div className="shell__main">
        <Header onToggleSidebar={() => setSidebarOpen((prev) => !prev)} />
        <div className="shell__content">{children}</div>
      </div>
    </div>
  );
}
